export interface CreateLeaderboardCluster {
  cluster: {
    corporate_id: number;
    initiative_id: number;
    name: string;
    description?: string;
    validity_start?: Date;
    validity_end?: Date;
    is_visible: boolean;
    anonymize: boolean;
  };
  owners: number[];
}

export interface LeaderboardClusterData {
  id: number;
  corporate_id: number;
  initiative_id: number;
  name: string;
  description?: string;
  validity_start?: Date;
  validity_end?: Date;
  is_visible: boolean;
  anonymize: boolean;
}

export interface LeaderboardClusterOwnerData {
  id_user: number;
  corporate_id: number;
  external_id: string;
  name?: string;
  surname?: string;
  email?: string;
  username: string;
}

export interface LeaderboardClusterGroupData {
  id: number;
  name: string;
  corporate_id: number;
}

export interface LeaderboardClusterInitiativeData {
  id: number;
  name: string;
}

export interface LeaderboardClusterLearningObjectData {
  cluster_id: number;
  lo_id: number;
  title?: string;
}

export interface LeaderboardClusterCommunityClusterData {
  id: number;
  corporate_id: number;
  initiative_id: number;
  name: string;
  is_post_enabled: boolean;
  is_share_enabled: boolean;
  is_talk_enabled: boolean;
  is_visible: boolean;
  drupal_id?: number;
}

export interface LeaderboardClusterCommunityScoringData {
  cluster_id: number;
  talk_score?: number;
  post_score?: number;
  share_score?: number;
  like_score?: number;
  comment_score?: number;
}

export interface GetLeaderboardClusterData {
  cluster: LeaderboardClusterData;
  owners?: LeaderboardClusterOwnerData[];
  groups?: LeaderboardClusterGroupData[];
  initiatives?: LeaderboardClusterInitiativeData[];
  target_learning_objects?: LeaderboardClusterLearningObjectData[];
  scoring_learning_objects?: LeaderboardClusterLearningObjectData[];
  community_clusters?: LeaderboardClusterCommunityClusterData[];
  scoring_community?: LeaderboardClusterCommunityScoringData;
}

export interface ListGetLeaderboardClusterData {
  metadata: {
    total_pages: number;
    total_elements: number;
  };
  output: GetLeaderboardClusterData[];
}

export interface LinkLeaderboardClusterBody {
  initiatives?: number[];
  groups?: number[];
  learning_objects?: number[];
}

export interface UpdateScoringLeaderboardClusterBody {
  scoring_learning_objects?: number[];
  community_clusters?: number[];
  scoring_community?: LeaderboardClusterCommunityScoringData;
}

// export interface ClusterUser {
//   id: number;
//   external_id: string;
//   name?: string;
//   surname?: string;
//   email?: string;
//   group_id?: number[];
//   group_name?: string[];
// }

// export interface ListClusterUser {
//   metadata: {
//     total_pages: number;
//     total_elements: number;
//   };
//   output: ClusterUser[];
// }

export interface LeaderboardPosition {
  studentEid: string;
  domainId: number;
  corporateId: number;
  totalScore: number;
  ranking: number;
  trend: string;
  studentName: string;
  user?: {
    id: number;
    externalId: string;
    name: string;
    surname: string;
    email: string;
    groupId?: number[];
    groupName?: string[];
  };
}

export interface ListLeaderboardPosition {
  leaderboards: LeaderboardPosition[];
  metadata: {
    totalElements: number;
    totalPages: number;
  };
}

export const checkAssociationChanged = (
  prev: Record<number, boolean>,
  cur: Record<number, boolean>,
): boolean => {
  const keysPrev = Object.keys(prev);
  const keysCur = Object.keys(cur);
  if (keysPrev.length === 0 && keysCur.length === 0) {
    return false;
  }
  if (keysPrev.length !== keysCur.length) {
    return true;
  }
  for (const key of keysPrev) {
    if (
      keysPrev[key as unknown as number] !== keysCur[key as unknown as number]
    ) {
      return true;
    }
  }
  return false;
};
